import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Formik, Field, Form } from 'formik';
import useOutsideClick from 'utils/useOutsideClick';
import classnames from 'classnames';
import withLoader from 'components/organisms/withLoader';
import CloseIcon from '../../icons/closeIcon';
import RadioButton from '../../radioButton';
import UpdateHoldingStatusCcm from './ccm';

const UpdatePatientHoldingStatusModal = ({
  toggle,
  patientGuid,
  patientHoldingStatus,
  patientHoldingStatusLoading,
  options,
  loading,
  submit,
  isCcmPage,
}) => {
  const ref = useRef();
  useOutsideClick(ref, () => toggle(false));

  const handleSubmit = async (values) => {
    const needRemove = values.holdingStatus === patientHoldingStatus;
    const postData = {
      patientGuid,
      holdingStatus: needRemove ? null : values.holdingStatus,
      days: needRemove ? undefined : values.days,
    };
    await submit(postData);
  };
  return (
    <div className="holding-status-popup" ref={ref}>
      <div className="holding-status-popup__title">Holding Status</div>
      <div
        className="holding-status-popup__close-btn"
        onClick={() => toggle(false)}
      >
        <CloseIcon />
      </div>
      {withLoader(
        patientHoldingStatusLoading,
        <Formik
          initialValues={{
            holdingStatus: patientHoldingStatus,
            days: options.find((option) => option.id === patientHoldingStatus)
              ?.days,
          }}
          onSubmit={handleSubmit}
        >
          {({ values: { holdingStatus } }) => (
            <Form>
              <div className="holding-status-popup__content">
                <div className="holding-status-popup__field">
                  <h6 className="holding-status-popup__field-title">Reason</h6>
                  <Field name="holdingStatus">
                    {({ field, form }) =>
                      options.map((option, index) => (
                        <RadioButton
                          key={index}
                          name="status"
                          id={option.id}
                          label={option.label}
                          onChange={() => {
                            form.setFieldValue('holdingStatus', option.id);
                            form.setFieldValue('days', option.days);
                          }}
                          isChecked={field.value === option.id}
                        />
                      ))
                    }
                  </Field>
                </div>
                <div className="holding-status-popup__field">
                  <h6 className="holding-status-popup__field-title">Days</h6>
                  <div className="holding-status-popup__days">
                    <Field name="days">
                      {({ field }) =>
                        options.map((option, index) => (
                          <div
                            className={classnames(
                              'holding-status-popup__days-count',
                              {
                                active: field.value === option.days,
                              },
                            )}
                            key={index}
                          >
                            <span>{option.days}</span>
                          </div>
                        ))
                      }
                    </Field>
                  </div>
                </div>
              </div>
              <div className="holding-status-popup__control">
                <button
                  className="holding-status-popup__button"
                  type="submit"
                  disabled={
                    loading || !holdingStatus || holdingStatus === 'active'
                  }
                >
                  {patientHoldingStatus &&
                  patientHoldingStatus === holdingStatus &&
                  patientHoldingStatus !== 'active'
                    ? 'Remove'
                    : 'Done'}
                </button>
              </div>
            </Form>
          )}
        </Formik>,
      )}
      {isCcmPage && <UpdateHoldingStatusCcm />}
    </div>
  );
};

UpdatePatientHoldingStatusModal.defaultProps = {
  patientHoldingStatus: 'active',
};

UpdatePatientHoldingStatusModal.propTypes = {
  toggle: PropTypes.func.isRequired,
  patientGuid: PropTypes.string.isRequired,
  patientHoldingStatus: PropTypes.string,
  patientHoldingStatusLoading: PropTypes.bool.isRequired,
  options: PropTypes.array,
  loading: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
  isCcmPage: PropTypes.bool,
};

export default UpdatePatientHoldingStatusModal;
